export default function shouldDisplayNameBeTranslated(displayName) {
  return ['click_to_dial', 'anonymous', 'unknown'].includes(displayName);
}
